const TpCreditMemoStatusEnum = {
  Created: 'Created',
  ApprovedBySubmitter: 'Approved By Submitter',
  ApprovedByLineManager: 'Approved By Line Manager',
  ApprovedByCMApprover: 'Approved By CM Approver',
  Declined: 'Declined',
  Finalized: 'Finalized',
};

export default TpCreditMemoStatusEnum;
